function Register() {
  return <div>This is Register</div>;
}

export default Register;
